/* eslint-disable jsx-a11y/anchor-is-valid */
import React, {useEffect, useState} from 'react'
import {useNavigate} from 'react-router-dom'
import {getLayoutFromLocalStorage, ILayout, LayoutSetup} from '../../../_metronic/layout/core'
import {ToolbarClassic} from '../../../_metronic/layout/components/toolbar/toolbars'
import {useAuth} from '../../modules/auth'
import {dummyClaimsData} from '../../../data/claims'
import ChatModal from '../layout-inpatient/tab-components/ChatModal'
import {FaComment, FaEdit} from 'react-icons/fa'
import axios from 'axios'
import moment from 'moment'
import {useIntl} from 'react-intl'
import {useDebounce} from '../../../_metronic/helpers'
import {useClaims, useMyTurnTotal} from '../../../hooks/useClaims'
import {useQueryClient} from 'react-query'
import {FaSync} from 'react-icons/fa'

interface Claim {
  id: string
  memberName: string
  claimNumber: string
  cardNumber: string
  policyNumber: string
  customerGroup: string
  status: string
  claimDate: string
  claimType: string
  treatmentType: string
}

interface BuilderPageProps {
  searchType: string
  searchQuery: string
  onSearchTypeChange: (value: string) => void
  onSearchQueryChange: (value: string) => void
  currentPage: number
  onPageChange: (page: number) => void
}

const BuilderPage: React.FC<BuilderPageProps> = ({
  searchType,
  searchQuery,
  onSearchTypeChange,
  onSearchQueryChange,
  currentPage,
  onPageChange,
}) => {
  const {formatMessage: f} = useIntl()
  const navigate = useNavigate()
  const [setTab] = useState('Sidebar')
  const [config, setConfig] = useState<ILayout>(getLayoutFromLocalStorage())
  const [configLoading, setConfigLoading] = useState<boolean>(false)
  const [resetLoading, setResetLoading] = useState<boolean>(false)
  const {currentUser} = useAuth()
  const auth = useAuth()
  const queryClient = useQueryClient()
  const [pageSize, setPageSize] = useState(10)
  const [isChatModalOpen, setIsChatModalOpen] = useState<boolean>(false)
  const [claimDetails, setClaimDetails] = useState<any>(null)
  const [activeTab, setActiveTab] = useState<'all' | 'myturn'>('all')
  const [loadingClaimNo, setLoadingClaimNo] = useState<string | null>(null)
  const [isRefreshing, setIsRefreshing] = useState<boolean>(false)

  // Debounce search query to avoid excessive API calls
  const debouncedSearchQuery = useDebounce(searchQuery, 500)

  // Show loading indicator when search is being debounced
  const isSearchDebouncing = searchQuery !== debouncedSearchQuery

  // React Query hooks
  const claimsParams = {
    searchType,
    searchQuery: debouncedSearchQuery,
    currentPage,
    pageSize,
    activeTab,
  }

  console.log('BuilderPage - claimsParams:', claimsParams)
  console.log('BuilderPage - currentUser:', currentUser)
  console.log('BuilderPage - auth:', auth)

  const {
    data: claimsData,
    isLoading: loading,
    error: claimsError,
    refetch: refetchClaims,
    isFetching,
    isError,
    claims,
    totalPages,
    totalRecords,
  } = useClaims(claimsParams)

  const {totalRecords: myTurnTotalRecords} = useMyTurnTotal()

  console.log('BuilderPage - claimsData:', claimsData)
  console.log('BuilderPage - loading:', loading)
  console.log('BuilderPage - isFetching:', isFetching)
  console.log('BuilderPage - claimsError:', claimsError)
  console.log('BuilderPage - isError:', isError)

  // Handle 401 errors from React Query
  useEffect(() => {
    if (claimsError && (claimsError as any)?.response?.status === 401) {
      auth.logout()
      navigate('/login')
    }
  }, [claimsError, auth, navigate])

  // Refresh function to invalidate queries
  const handleRefresh = async () => {
    setIsRefreshing(true)
    try {
      // Invalidate both claims queries to force refetch
      await Promise.all([
        queryClient.invalidateQueries(['claims']),
        queryClient.invalidateQueries(['myTurnTotal']),
      ])
    } catch (error) {
      console.error('Error refreshing claims:', error)
    } finally {
      setIsRefreshing(false)
    }
  }

  const handlePageChange = (page: number) => {
    onPageChange(page)
  }

  // Debug log for render
  // console.log('Current claims:', claims);
  // console.log('Current page:', currentPage);
  // console.log('Loading state:', loading);

  const updateConfig = () => {
    setConfigLoading(true)
    try {
      LayoutSetup.setConfig(config)
      window.location.reload()
    } catch (error) {
      setConfig(getLayoutFromLocalStorage())
      setConfigLoading(false)
    }
  }

  const reset = () => {
    setResetLoading(true)
    setTimeout(() => {
      setConfig(getLayoutFromLocalStorage())
      setResetLoading(false)
    }, 1000)
  }

  const fetchClaimDetails = async (claimNumber: string) => {
    const apiUrl = `${process.env.REACT_APP_API_PROVIDER_URL}/api/Claims/GetByClaimNumber/${claimNumber}`
    // const apiUrl = `${process.env.REACT_APP_API_CLAIM_URL_NGROK}/api/Provider/GetByClaimNumber/${claimNumber}`
    try {
      const response = await axios.get(apiUrl, {
        headers: {
          Authorization: `Bearer ${auth.currentUser?.token}`,
          'ngrok-skip-browser-warning': 'true', // 👈 this is the magic header
        },
      })
      // console.log("Claim details fetched:", response.data);
      return response.data
    } catch (error) {
      console.error('Error fetching claim details:', error)
      return null
    }
  }

  const handleChatAction = async (claim: Claim) => {
    const details = await fetchClaimDetails(claim.claimNumber)
    if (details) {
      setClaimDetails(details)
      setIsChatModalOpen(true)
    }
  }

  const handleClaimAction = async (claim: Claim) => {
    const claimDetails = await fetchClaimDetails(claim.claimNumber)
    if (claimDetails) {
      if (claim.treatmentType === 'Rawat jalan') {
        navigate('/outpatient', {state: {claimDetails}})
      } else {
        navigate('/inpatient', {state: {claimDetails}})
      }
    }
  }

  // console.log("Status Claim : ",JSON.stringify(claims));

  // const getStatusStyle = (status: string) => {
  //   switch (status) {
  //     case 'Initial Document Complete':
  //       return {
  //         backgroundColor: 'rgba(16, 185, 129, 0.1)',
  //         color: '#10B981', // Green
  //       }
  //     case 'Final Document Complete':
  //       return {
  //         backgroundColor: 'rgba(0, 150, 136, 0.1)',
  //         color: '#009688', // Teal
  //       }
  //     case 'Pre-Registered':
  //       return {
  //         backgroundColor: 'rgba(59, 130, 246, 0.1)',
  //         color: '#3B82F6', // Blue
  //       }
  //     case 'Daily Monitoring':
  //       return {
  //         backgroundColor: 'rgba(147, 51, 234, 0.1)',
  //         color: '#9333EA', // Purple
  //       }
  //     case 'SOA RELEASED':
  //       return {
  //         backgroundColor: 'rgba(245, 158, 11, 0.1)',
  //         color: '#F59E0B', // Amber
  //       }
  //     case 'Claim Verified':
  //       return {
  //         backgroundColor: 'rgba(16, 185, 129, 0.1)',
  //         color: '#10B981', // Green
  //       }
  //     case 'Pending On Verification':
  //       return {
  //         backgroundColor: 'rgba(249, 115, 22, 0.1)',
  //         color: '#F97316', // Orange
  //       }
  //     default:
  //       return {
  //         backgroundColor: 'rgba(156, 163, 175, 0.1)',
  //         color: '#6B7280', // Gray
  //       }
  //   }
  // }

  const onProviderStatuses = [
    'Pre-Registered',
    'Pending on IGL',
    'IGL Released',
    'Daily Monitoring',
    // 'Supercreeding request',
    'Waiting Enquiry Response',
    'Pending on FGL',
  ]

  const onHostStatuses = [
    'New Case',
    'Admission Review',
    'Initial Document Complete',
    'Request FGL',
    'FGL Review',
    'Final Document Complete',
  ]

  const getStatusStyles = (status: string) => {
    // Check if the status is in redSectionStatuses
    const isProviderStatus = onProviderStatuses.includes(status)
    const isHostStatus = onHostStatuses.includes(status)

    if (isProviderStatus) {
      return {
        backgroundColor: 'rgba(59, 130, 246, 0.1)',
        color: '#3B82F6', // Blue
      }
    } else if (isHostStatus) {
      return {
        backgroundColor: 'rgba(16, 185, 129, 0.1)',
        color: '#10B981', // Green
      }
    } else {
      return {
        backgroundColor: 'rgba(156, 163, 175, 0.1)',
        color: '#6B7280', // Gray
      }
    }
  }

  // Use claims directly from React Query
  const filteredClaims = claims

  const renderPagination = () => {
    const totalPagesArray = Array.from({length: totalPages}, (_, index) => index + 1)
    const pageLimit = 5
    let startPage = Math.max(1, currentPage - Math.floor(pageLimit / 2))
    let endPage = Math.min(totalPages, startPage + pageLimit - 1)

    if (endPage - startPage < pageLimit - 1) {
      startPage = Math.max(1, endPage - pageLimit + 1)
    }

    const paginationButtonStyle = {
      minWidth: '36px',
      height: '36px',
      padding: '0',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      fontSize: '0.95rem',
      fontWeight: '500',
      borderRadius: '6px',
      transition: 'all 0.2s ease',
      border: '1px solid #e9ecef',
      backgroundColor: '#fff',
      color: '#2D3748',
    }

    const activePaginationStyle = {
      ...paginationButtonStyle,
      backgroundColor: '#EBF7F9',
      borderColor: '#059BB6',
      color: '#059BB6',
    }

    return (
      <div className='d-flex gap-2 align-items-center'>
        <button
          className='btn btn-icon'
          onClick={() => onPageChange(1)}
          disabled={currentPage === 1}
          style={{
            ...paginationButtonStyle,
            opacity: currentPage === 1 ? 0.5 : 1,
            cursor: currentPage === 1 ? 'not-allowed' : 'pointer',
          }}
        >
          «
        </button>

        <button
          className='btn btn-icon'
          onClick={() => onPageChange(currentPage - 1)}
          disabled={currentPage === 1}
          style={{
            ...paginationButtonStyle,
            opacity: currentPage === 1 ? 0.5 : 1,
            cursor: currentPage === 1 ? 'not-allowed' : 'pointer',
          }}
        >
          ‹
        </button>

        {startPage > 1 && (
          <>
            <button
              className='btn btn-icon'
              onClick={() => onPageChange(1)}
              style={paginationButtonStyle}
            >
              1
            </button>
            {startPage > 2 && <span style={{color: '#6B7280', padding: '0 4px'}}>...</span>}
          </>
        )}

        {totalPagesArray.slice(startPage - 1, endPage).map((page) => (
          <button
            key={page}
            className='btn btn-icon'
            onClick={() => onPageChange(page)}
            style={currentPage === page ? activePaginationStyle : paginationButtonStyle}
          >
            {page}
          </button>
        ))}

        {endPage < totalPages && (
          <>
            {endPage < totalPages - 1 && (
              <span style={{color: '#6B7280', padding: '0 4px'}}>...</span>
            )}
            <button
              className='btn btn-icon'
              onClick={() => onPageChange(totalPages)}
              style={paginationButtonStyle}
            >
              {totalPages}
            </button>
          </>
        )}

        <button
          className='btn btn-icon'
          onClick={() => onPageChange(currentPage + 1)}
          disabled={currentPage === totalPages}
          style={{
            ...paginationButtonStyle,
            opacity: currentPage === totalPages ? 0.5 : 1,
            cursor: currentPage === totalPages ? 'not-allowed' : 'pointer',
          }}
        >
          ›
        </button>

        <button
          className='btn btn-icon'
          onClick={() => onPageChange(totalPages)}
          disabled={currentPage === totalPages}
          style={{
            ...paginationButtonStyle,
            opacity: currentPage === totalPages ? 0.5 : 1,
            cursor: currentPage === totalPages ? 'not-allowed' : 'pointer',
          }}
        >
          »
        </button>
      </div>
    )
  }

  return (
    <>
      <div
        className='card card-custom'
        style={{
          borderRadius: '12px',
          boxShadow: '0 2px 4px rgba(0,0,0,0.05)',
          border: '1px solid #e9ecef',
          marginTop: '30px',
        }}
      >
        <div
          className='card-header'
          style={{
            padding: '0.5rem',
            borderBottom: '1px solid #e9ecef',
            backgroundColor: '#fff',
          }}
        >
          <div className='d-flex flex-column gap-1'>
            <div className='d-flex align-items-center gap-2'>
              <div
                className='d-flex'
                style={{
                  backgroundColor: '#f8f9fa',
                  padding: '2px',
                  borderRadius: '10px',
                  border: '1px solid #e9ecef',
                }}
              >
                <button
                  onClick={() => setActiveTab('all')}
                  className='btn'
                  style={{
                    padding: '8px 24px',
                    borderRadius: '8px',
                    fontSize: '0.95rem',
                    fontWeight: '500',
                    transition: 'all 0.2s ease',
                    backgroundColor: activeTab === 'all' ? '#fff' : 'transparent',
                    color: activeTab === 'all' ? '#059BB6' : '#6B7280',
                    boxShadow: activeTab === 'all' ? '0 2px 4px rgba(0,0,0,0.05)' : 'none',
                    border: 'none',
                  }}
                >
                  {f({id: 'CLAIM.ALL_CLAIMS'})}
                </button>
                <button
                  onClick={() => setActiveTab('myturn')}
                  className='btn'
                  style={{
                    padding: '8px 24px',
                    borderRadius: '8px',
                    fontSize: '0.95rem',
                    fontWeight: '500',
                    transition: 'all 0.2s ease',
                    backgroundColor: activeTab === 'myturn' ? '#fff' : 'transparent',
                    color: activeTab === 'myturn' ? '#059BB6' : '#6B7280',
                    boxShadow: activeTab === 'myturn' ? '0 2px 4px rgba(0,0,0,0.05)' : 'none',
                    border: 'none',
                    display: 'flex',
                    alignItems: 'center',
                    gap: '8px',
                    position: 'relative',
                  }}
                >
                  {f({id: 'CLAIM.MY_TURN'})}
                  {myTurnTotalRecords > 0 && (
                    <span
                      style={{
                        backgroundColor: '#DC2626',
                        color: '#fff',
                        padding: '2px 8px',
                        borderRadius: '12px',
                        fontSize: '0.8rem',
                        fontWeight: '600',
                        minWidth: '20px',
                        height: '20px',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                      }}
                    >
                      {myTurnTotalRecords}
                    </span>
                  )}
                </button>
              </div>
              <button
                className='btn btn-light-primary'
                onClick={handleRefresh}
                disabled={isRefreshing || loading}
                style={{
                  padding: '0.65rem 1rem',
                  borderRadius: '8px',
                  fontSize: '0.95rem',
                  fontWeight: '500',
                  display: 'flex',
                  alignItems: 'center',
                  gap: '8px',
                  transition: 'all 0.2s ease',
                  minWidth: '120px',
                  justifyContent: 'center',
                }}
                title={f({id: 'CLAIM.REFRESH_TOOLTIP'}) || 'Refresh claims list'}
              >
                <FaSync
                  className={isRefreshing ? 'fa-spin' : ''}
                  style={{
                    fontSize: '14px',
                    animation: isRefreshing ? 'spin 1s linear infinite' : 'none',
                  }}
                />
                {isRefreshing
                  ? f({id: 'CLAIM.REFRESHING'}) || 'Refreshing...'
                  : f({id: 'CLAIM.REFRESH'}) || 'Refresh'}
              </button>
            </div>

            <div className='card-toolbar d-flex justify-content-between align-items-center flex-wrap gap-2'>
              <div
                className='d-flex align-items-center gap-3'
                style={{width: '100%', maxWidth: '800px'}}
              >
                <div
                  className='input-group'
                  style={{
                    flex: 1,
                    boxShadow: '0 2px 4px rgba(0,0,0,0.02)',
                  }}
                >
                  <select
                    className='form-select'
                    value={searchType}
                    onChange={(e) => onSearchTypeChange(e.target.value)}
                    style={{
                      width: '40%',
                      fontSize: '0.95rem',
                      background: '#f8f9fa',
                      color: '#2D3748',
                      border: '1px solid #e9ecef',
                      borderRadius: '8px 0 0 8px',
                      padding: '0.65rem 1rem',
                      appearance: 'none',
                      backgroundImage:
                        "url(\"data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='%232D3748'><path d='M7 10l5 5 5-5H7z'/></svg>\")",
                      backgroundRepeat: 'no-repeat',
                      backgroundPosition: 'right 12px center',
                      backgroundSize: '16px',
                      transition: 'all 0.2s ease',
                    }}
                  >
                    <option value='Nama Member'>{f({id: 'CLAIM.SEARCH.NAME_MEMBER'})}</option>
                    <option value='Claim Number'>{f({id: 'CLAIM.SEARCH.CLAIM_NUMBER'})}</option>
                    <option value='Card Number'>{f({id: 'CLAIM.SEARCH.CARD_NUMBER'})}</option>
                    <option value='Benefit'>{f({id: 'CLAIM.SEARCH.BENEFIT'})}</option>
                    <option value='Customer Group'>{f({id: 'CLAIM.SEARCH.CUSTOMER_GROUP'})}</option>
                    <option value='Created Date'>{f({id: 'CLAIM.SEARCH.CREATED_DATE'})}</option>
                    <option value='Status'>{f({id: 'CLAIM.SEARCH.STATUS'})}</option>
                  </select>

                  <input
                    type='text'
                    className='form-control'
                    placeholder={f({id: 'CLAIM.SEARCH.PLACEHOLDER'})}
                    style={{
                      width: '60%',
                      fontSize: '0.95rem',
                      border: '1px solid #e9ecef',
                      borderLeft: 'none',
                      borderRadius: '0 8px 8px 0',
                      padding: '0.65rem 1rem',
                      transition: 'all 0.2s ease',
                    }}
                    value={searchQuery}
                    onChange={(e) => onSearchQueryChange(e.target.value)}
                  />
                </div>
              </div>
            </div>
          </div>
          <div style={{marginTop: '0.25rem'}}>
            <ToolbarClassic claimType='INPATIENT' onModalClose={() => {}} />
          </div>
        </div>
        {loading || isRefreshing ? (
          <div
            className='d-flex justify-content-center align-items-center'
            style={{height: '300px'}}
          >
            <div
              className='spinner-border'
              style={{color: '#059BB6', width: '3rem', height: '3rem'}}
              role='status'
            >
              <span className='visually-hidden'>{f({id: 'DASHBOARD.LOADING'})}</span>
            </div>
          </div>
        ) : isError ? (
          <div className='alert alert-danger m-5' style={{borderRadius: '8px'}}>
            {(claimsError as any)?.message || 'Failed to fetch claims'}
          </div>
        ) : claims.length === 0 ? (
          <div
            className='alert alert-info m-5'
            style={{
              borderRadius: '8px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              padding: '2rem',
              backgroundColor: '#EBF7F9',
              border: '1px dashed #059BB6',
              color: '#059BB6',
            }}
          >
            <div className='text-center'>
              <div
                style={{
                  fontSize: '1.1rem',
                  fontWeight: '500',
                  marginBottom: '0.5rem',
                }}
              >
                {f({id: 'CLAIM.NO_CLAIMS_FOUND'})}
              </div>
              <div style={{fontSize: '0.9rem', color: '#6B7280'}}>
                {activeTab === 'all'
                  ? f({id: 'CLAIM.NO_CLAIMS_FOUND_ALL'})
                  : f({id: 'CLAIM.NO_CLAIMS_FOUND_MY_TURN'})}
              </div>
            </div>
          </div>
        ) : (
          <div className='card-body' style={{padding: '0.75rem'}}>
            <div className='table-responsive'>
              <table className='table table-striped gy-5 gs-5' style={{marginBottom: '1rem'}}>
                <thead>
                  <tr style={{backgroundColor: '#f8f9fa'}}>
                    <th
                      style={{
                        padding: '1rem',
                        fontWeight: '600',
                        color: '#2D3748',
                        borderBottom: '2px solid #e9ecef',
                      }}
                    >
                      {f({id: 'CLAIM.TABLE.NAME_MEMBER'})}
                    </th>
                    <th
                      style={{
                        padding: '1rem',
                        fontWeight: '600',
                        color: '#2D3748',
                        borderBottom: '2px solid #e9ecef',
                      }}
                    >
                      {f({id: 'CLAIM.TABLE.CLAIM_NUMBER'})}
                    </th>
                    <th
                      style={{
                        padding: '1rem',
                        fontWeight: '600',
                        color: '#2D3748',
                        borderBottom: '2px solid #e9ecef',
                      }}
                    >
                      {f({id: 'CLAIM.TABLE.CARD_NUMBER'})}
                    </th>
                    <th
                      style={{
                        padding: '1rem',
                        fontWeight: '600',
                        color: '#2D3748',
                        borderBottom: '2px solid #e9ecef',
                      }}
                    >
                      {f({id: 'CLAIM.TABLE.TREATMENT_TYPE'})}
                    </th>
                    <th
                      style={{
                        padding: '1rem',
                        fontWeight: '600',
                        color: '#2D3748',
                        borderBottom: '2px solid #e9ecef',
                      }}
                    >
                      {f({id: 'CLAIM.TABLE.CUSTOMER_GROUP'})}
                    </th>
                    <th
                      style={{
                        padding: '1rem',
                        fontWeight: '600',
                        color: '#2D3748',
                        borderBottom: '2px solid #e9ecef',
                      }}
                    >
                      {f({id: 'CLAIM.TABLE.CREATED_DATE'})}
                    </th>
                    <th
                      style={{
                        padding: '1rem',
                        fontWeight: '600',
                        color: '#2D3748',
                        borderBottom: '2px solid #e9ecef',
                      }}
                    >
                      {f({id: 'CLAIM.TABLE.STATUS'})}
                    </th>
                    <th
                      style={{
                        padding: '1rem',
                        fontWeight: '600',
                        color: '#2D3748',
                        borderBottom: '2px solid #e9ecef',
                      }}
                    >
                      {f({id: 'CLAIM.TABLE.ACTION'})}
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {filteredClaims.map((claim) => (
                    <tr key={claim.id} style={{transition: 'all 0.2s ease'}}>
                      <td style={{padding: '1rem', verticalAlign: 'middle'}}>{claim.memberName}</td>
                      <td style={{padding: '1rem', verticalAlign: 'middle'}}>
                        {claim.claimNumber}
                      </td>
                      <td style={{padding: '1rem', verticalAlign: 'middle'}}>{claim.cardNumber}</td>
                      <td style={{padding: '1rem', verticalAlign: 'middle'}}>
                        {claim.treatmentType === 'Rawat inap'
                          ? f({id: 'CLAIM.TABLE.INPATIENT'})
                          : f({id: 'CLAIM.TABLE.OUTPATIENT'})}
                      </td>
                      <td style={{padding: '1rem', verticalAlign: 'middle'}}>
                        {claim.customerGroup}
                      </td>
                      <td style={{padding: '1rem', verticalAlign: 'middle'}}>
                        {moment(claim.claimDate).utc().format('DD-MM-YYYY')}
                      </td>
                      <td style={{padding: '1rem', verticalAlign: 'middle'}}>
                        <span
                          style={{
                            padding: '0.5rem 0.75rem',
                            borderRadius: '6px',
                            fontSize: '0.85rem',
                            fontWeight: '500',
                            display: 'inline-block',
                            whiteSpace: 'nowrap',
                            textTransform: 'none',
                            border: 'none',
                            ...getStatusStyles(claim.status),
                          }}
                        >
                          {claim.status || 'Unknown'}
                        </span>
                      </td>
                      <td style={{padding: '1rem', verticalAlign: 'middle'}}>
                        <div className='d-flex align-items-center gap-2'>
                          <button
                            className='btn btn-icon btn-light-primary btn-sm action-button'
                            onClick={() => handleChatAction(claim)}
                            title='Chat Claim'
                            style={{
                              borderRadius: '6px',
                              width: '32px',
                              height: '32px',
                              padding: '0',
                              display: 'flex',
                              alignItems: 'center',
                              justifyContent: 'center',
                              transition: 'all 0.2s ease',
                            }}
                            onMouseEnter={(e) => {
                              const svg = e.currentTarget.querySelector('svg')
                              if (svg) svg.style.color = 'white'
                              e.currentTarget.style.backgroundColor = '#059BB6'
                            }}
                            onMouseLeave={(e) => {
                              const svg = e.currentTarget.querySelector('svg')
                              if (svg) svg.style.color = '#059BB6'
                              e.currentTarget.style.backgroundColor = ''
                            }}
                          >
                            <FaComment
                              style={{
                                color: '#059BB6',
                                width: '14px',
                                height: '14px',
                                transition: 'color 0.2s ease',
                              }}
                            />
                          </button>
                          <button
                            className='btn btn-icon btn-light-primary btn-sm action-button'
                            onClick={() => handleClaimAction(claim)}
                            title='Detail Claim'
                            style={{
                              borderRadius: '6px',
                              width: '32px',
                              height: '32px',
                              padding: '0',
                              display: 'flex',
                              alignItems: 'center',
                              justifyContent: 'center',
                              transition: 'all 0.2s ease',
                            }}
                            onMouseEnter={(e) => {
                              const svg = e.currentTarget.querySelector('svg')
                              if (svg) svg.style.color = 'white'
                              e.currentTarget.style.backgroundColor = '#059BB6'
                            }}
                            onMouseLeave={(e) => {
                              const svg = e.currentTarget.querySelector('svg')
                              if (svg) svg.style.color = '#059BB6'
                              e.currentTarget.style.backgroundColor = ''
                            }}
                          >
                            <FaEdit
                              style={{
                                color: '#059BB6',
                                width: '14px',
                                height: '14px',
                                transition: 'color 0.2s ease',
                              }}
                            />
                          </button>
                        </div>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>

              <div className='d-flex justify-content-between align-items-center flex-wrap gap-4'>
                <div style={{color: '#6B7280', fontSize: '0.95rem'}}>
                  {`Showing ${
                    filteredClaims.length > 0 ? (currentPage - 1) * pageSize + 1 : 0
                  } to ${Math.min(
                    currentPage * pageSize,
                    totalRecords
                  )} of ${totalRecords} entries`}
                </div>

                <div className='d-flex gap-2'>{renderPagination()}</div>
              </div>
            </div>
          </div>
        )}
      </div>

      {isChatModalOpen && claimDetails && (
        <ChatModal
          isOpen={isChatModalOpen}
          onClose={() => setIsChatModalOpen(false)}
          message=''
          claimDetails={claimDetails}
        />
      )}

      <style>
        {`
          .action-button {
            background-color: rgba(5, 155, 182, 0.1);
          }
          
          .action-button:hover {
            background-color: rgba(5, 155, 182, 0.2) !important;
          }
          
          .action-button:hover svg {
            opacity: 0.8;
          }

          @keyframes spin {
            from {
              transform: rotate(0deg);
            }
            to {
              transform: rotate(360deg);
            }
          }

          .fa-spin {
            animation: spin 1s linear infinite;
          }
        `}
      </style>
    </>
  )
}

export {BuilderPage}
